import { render, staticRenderFns } from "./RoomSelectWrapper.vue?vue&type=template&id=68687137"
import script from "./RoomSelectWrapper.vue?vue&type=script&lang=js"
export * from "./RoomSelectWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports